/**
 * AOZONE-59: admin-ui port of the slack-bot mbrPeriod picker constants
 * (apps/slack-bot/src/modalView.ts). Kept byte-for-byte aligned on the regex
 * and the 6-month rolling window — they are the same UX, just re-implemented
 * for React.
 */
export const MBR_PERIOD_OLDER_VALUE = 'OLDER';

/** YYYY-MM where MM is 01-12. */
export const MBR_PERIOD_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;

const MONTH_SHORT_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export interface MbrPeriodOption {
  value: string;
  label: string;
}

/**
 * Returns the current UTC month plus the five preceding months (6 total) as
 * `{value: 'YYYY-MM', label: 'MMM YYYY'}`, followed by a trailing "Older…"
 * sentinel whose value is `MBR_PERIOD_OLDER_VALUE`. Selecting "Older…" in the
 * UI reveals a free-text YYYY-MM input.
 */
export function buildMbrPeriodOptions(now: Date): MbrPeriodOption[] {
  const opts: MbrPeriodOption[] = [];
  const baseYear = now.getUTCFullYear();
  const baseMonth = now.getUTCMonth();
  for (let i = 0; i < 6; i++) {
    const d = new Date(Date.UTC(baseYear, baseMonth - i, 1));
    const y = d.getUTCFullYear();
    const m = d.getUTCMonth();
    opts.push({
      value: `${y}-${String(m + 1).padStart(2, '0')}`,
      label: `${MONTH_SHORT_NAMES[m]} ${y}`,
    });
  }
  opts.push({ value: MBR_PERIOD_OLDER_VALUE, label: 'Older…' });
  return opts;
}
